import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
import StatusDot from "./StatusDot";
const Status = (props) => {
  const {
    statusColor = "grey",
    className,
    prefix = "",
    small = false,
    label,
    statusDotPosition = "leading",
    ...other
  } = props;
  const classes = cx(`${prefix}status`, className, `${prefix}status--${statusColor}`, label && `${prefix}status--labelled ${prefix}status--${statusDotPosition}`, small && `${prefix}status--small`);
  return /* @__PURE__ */ jsxs("span", { className: classes, ...other, children: [
    label && /* @__PURE__ */ jsx("span", { className: `${prefix}status__label`, children: label }),
    /* @__PURE__ */ jsx(StatusDot, { statusDotPosition, prefix })
  ] });
};
var Status_default = Status;
export {
  Status_default as default
};
